// an easily mockable function to get current NODE_ENV
export default function getNodeEnv() {
  return process.env.NODE_ENV;
}
